import { Injectable, Inject } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
export class AppInsightsService {
private config: Microsoft.ApplicationInsights.IConfig = {
        instrumentationKey: this.instrumentationKey
    };
/**
 * @param {?} instrumentationKey
 */
constructor(
private instrumentationKey: string) {
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        }
    }
/**
 * @param {?=} name
 * @param {?=} url
 * @param {?=} properties
 * @param {?=} measurements
 * @param {?=} duration
 * @return {?}
 */
logPageView(name?: string, url?: string, properties?: any,
        measurements?: any, duration?: number) {
        AppInsights.trackPageView(name, url, properties, measurements, duration);
    }
/**
 * @param {?} name
 * @param {?=} properties
 * @param {?=} measurements
 * @return {?}
 */
logEvent(name: string, properties?: any, measurements?: any) {
        AppInsights.trackEvent(name, properties, measurements);
    }
/**
 * @param {?} exception
 * @param {?=} handledAt
 * @param {?=} properties
 * @param {?=} measurements
 * @return {?}
 */
logException(exception: Error, handledAt?: string, properties?: any, measurements?: any) {
        AppInsights.trackException(exception, handledAt, properties, measurements);
    }
/**
 * @param {?} message
 * @param {?=} properties
 * @param {?=} severityLevel
 * @return {?}
 */
logTrace(message: string, properties?: any, severityLevel?: any) {
        AppInsights.trackTrace(message, properties, severityLevel);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: ['instrumentationKey', ] }, ]},
];
}

function AppInsightsService_tsickle_Closure_declarations() {
/** @type {?} */
AppInsightsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AppInsightsService.ctorParameters;
/** @type {?} */
AppInsightsService.prototype.config;
/** @type {?} */
AppInsightsService.prototype.instrumentationKey;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
